import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';

interface TryItCtaProps {
  to: string;
  label?: string;
}

export function TryItCta({ to, label = 'Pruebalo tu mismo' }: TryItCtaProps) {
  const navigate = useNavigate();

  return (
    <div className="mt-6 pt-4 border-t">
      <Button onClick={() => navigate(to)} className="gap-2">
        <ExternalLink className="w-4 h-4" />
        {label}
      </Button>
    </div>
  );
}
